import React from 'react';
import {
  Button,
  CssBaseline,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
  ButtonGroup,
  Typography,
} from '@material-ui/core';

import swal from '@sweetalert/with-react';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
import SubTitle from '../components/Text/SubTitle';

const APPLY_INFO = [
  {
    contact: 'Korean Society of Plastic and Reconstructive Surgeons',
    contactKor: '대한성형외과학회',
    email: 'kprs@plasticsurgery.or.kr',
    tel: '+82-2-3472-4253',
  },
  {
    contact: 'PRS KOREA 2022 Secretariat',
    contactKor: 'PRS KOREA 2022 사무국',
    email: 'secretariat.kprs@innon.co.kr',
    tel: '+82-2-6411-7378',
  },
];

const ACCOUNT_INFO = {
  'Bank Name': 'Hana Bank',
  'Account Number': '224-910038-66804',
  'Beneficiary Account': 'Korean Society of Plastic and Reconstructive Surgeons (KSPRS)',
  'Swift Code': 'KOEXKRSE or KOEXKRSEXXX',
  'Branch Name': 'Seochonam Banking Center',
  'Bank Address': '06733, Seoun-ro 3, Seocho-gu, Seoul',
};

const DOWNLOAD_BTN = [
  { title: '통장사본', titleEng: 'A Copy of Bankbook', bgcolor: '#e16d7a', isOpen: true },
  { title: '사업자등록증', titleEng: 'Business License', bgcolor: '#7d889a', isOpen: true },
  {
    title: '협력업체 참가신청 안내공문',
    titleEng: 'General Exhibition & Advertisement Participation Application Guide',
    bgcolor: '#194579',
    isOpen: true,
  },
  { title: '스폰서 참가신청 안내공문', titleEng: 'Sponsor Participation Application Guide', bgcolor: '#4472C4', isOpen: true },
  { title: '스폰서 신청서', titleEng: 'Sponsor Application Form', bgcolor: '#14A83B', isOpen: true },

  {
    title: '대한의사협회 인증공문',
    titleEng: 'Certified Official Notice of the Korean Medical Association',
    bgcolor: '#e0c243',
    isOpen: true,
  },
  { title: '부스 레이아웃', titleEng: 'Booth Layout', bgcolor: '#4169E1', isOpen: true },
];

const DOWNLOAD_BTN_EN = [
  { title: '통장사본', titleEng: 'A Copy of Bankbook', bgcolor: '#e16d7a', isOpen: true },
  { title: '사업자등록증', titleEng: 'Business License', bgcolor: '#7d889a', isOpen: true },
  {
    title: '협력업체 참가신청 안내공문',
    titleEng: 'General Exhibition & Advertisement Participation Application Guide',
    bgcolor: '#194579',
    isOpen: true,
  },
  { title: '스폰서 참가신청 안내공문', titleEng: 'Sponsor Participation Application Guide', bgcolor: '#4472C4', isOpen: true },
  { title: '스폰서 신청서', titleEng: 'Sponsor Application Form', bgcolor: '#14A83B', isOpen: true },
  { titleEng: 'Genetal Exhibition & Advertisement Application Form', bgcolor: '#0064CD', isOpen: true },
  // {
  //   title: '대한의사협회 인증공문',
  //   titleEng: 'Certified Official Notice of the Korean Medical Association',
  //   bgcolor: '#e0c243',
  //   isOpen: false,
  // },
  { title: '부스 레이아웃', titleEng: 'Booth Layout', bgcolor: '#4169E1', isOpen: true },
];

const styles = (theme) => ({
  downloadBtn: {
    padding: theme.spacing(0, 1),
  },
  provide: {
    '& > p': {
      textAlign: 'left',
      lineHeight: '2em',
      textIndent: '-1em',
      paddingLeft: '1em',
      '& > span': {
        display: 'block',
        textIndent: '0.1em',
      },
    },
    '& > div': {
      textAlign: 'left',
      '& > p': {
        paddingLeft: '0.65em',
        textIndent: '-0.65em',
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    textAlign: 'center',
    fontSize: '1.2em',
    fontWeight: 500,
    border: '2px solid #fff',
  },
  body: {
    backgroundColor: '#e9eef1',
    color: '#000000',

    // color: '#555',
    textAlign: 'center',
    fontSize: '1.2em',
    // fontWeight: 500,
    fontWeight: 500,
    border: '2px solid #fff',
    wordBreak: 'keep-all',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    fontWeight: 500,
    // '&:nth-of-type(odd)': {
    //   backgroundColor: '#f9fafb',
    // },
    // '&:nth-of-type(even)': {
    //   backgroundColor: '#f4f7fa',
    // },
  },
}))(TableRow);

class SponsorInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      coNum: '',
      tabValue: 0,
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    this.handleState = this.handleState.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSignIn = this.handleSignIn.bind(this);
    this.goSite = this.goSite.bind(this);
  }

  componentDidMount() {}

  componentWillUnmount() {}

  goSite() {}

  downloadFile(d) {
    //eslint-disable-next-line
    if (d.isOpen == false) {
      swal('', 'To be updated.', 'info');
    } else {
      if (d.title === '통장사본') {
        window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/prs2022_account.jpg');
      } else if (d.title === '사업자등록증') {
        if (this.state.tabValue === 0) {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/PRS2022_BUSINESS_LICENSE.pdf');
        } else {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/Certificate+of+Business+Registration.pdf');
        }
      } else if (d.title === '참가신청 안내공문') {
        window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2021/sponsor/exhibition_ad_application_guide.pdf');
      } else if (d.title === '스폰서 참가신청 안내공문') {
        if (this.state.tabValue === 0) {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/sponsor_application_revised.pdf');
        } else {
          window.open(
            'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022_Sponsor+Participation+Application+Guide.pdf',
          );
        }
      } else if (d.title === '스폰서 신청서') {
        if (this.state.tabValue === 0) {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/sponsor_application_form_revised.docx');
        } else {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022_Sponsor_Application_Form.docx');
        }
      } else if (d.title === '대한의사협회 인증공문') {
        if (this.state.tabValue === 0) {
          window.open(
            'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/%EB%B6%99%EC%9E%841.+%EB%8C%80%ED%95%9C%EC%9D%98%EC%82%AC%ED%98%91%ED%9A%8C+%EC%9D%B8%EC%A0%95+%ED%86%B5%EB%B3%B4+%EA%B3%B5%EB%AC%B8(%EB%8C%80%EC%9D%98%ED%98%91+%EC%A0%9C493-04694%ED%98%B8+2022.07.25).pdf',
          );
        }
      } else if (d.title === '부스 레이아웃') {
        // window.open(
        //   'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022+%EB%B6%80%EC%8A%A4%EB%B0%B0%EC%B9%98%EB%8F%84.pdf',
        // );

        if (this.state.tabValue === 0) {
          window.open(
            'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022+%EB%B6%80%EC%8A%A4%EB%B0%B0%EC%B9%98%EB%8F%84.pdf',
          );
        } else {
          window.open('https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022+Booth+Layout_ENG.pdf');
        }
      } else if (d.title === '협력업체 참가신청 안내공문') {
        // window.open(
        //   'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022+%EC%A0%84%EC%8B%9C+%EA%B4%91%EA%B3%A0+%EC%8B%A0%EC%B2%AD+%EC%95%88%EB%82%B4.pdf',
        // );

        if (this.state.tabValue === 0) {
          window.open(
            'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/PRS+KOREA+2022+%EC%A0%84%EC%8B%9C+%EA%B4%91%EA%B3%A0+%EC%8B%A0%EC%B2%AD+%EC%95%88%EB%82%B4.pdf',
          );
        } else {
          window.open(
            'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/Information+on+the+Exhibition%26Advertisement+Application+of+PRS+KOREA+2022+(2).pdf',
          );
        }
      } else {
        window.open(
          'https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/sponsor/Genera+Exhibition+%26+Advertisement+Participation+Application+Form_FINAL.docx',
        );
      }
    }
  }

  handleSignIn(event) {
    event.preventDefault();

    const coNum = this.state.coNum.replace(/ /gi, '');

    if (coNum.length < 1) {
      swal('사업자등록번호를 입력하세요.');
      return;
    }
  }

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }
  handleState(key, value) {
    this.setState({ [key]: value });
  }
  render() {
    const { classes, theme } = this.props;
    const { tabValue } = this.state;

    const spaceDiv = () => {
      return (
        <Grid item xs={8}>
          <div style={{ height: '30px' }} />
        </Grid>
      );
    };

    const arrDataRender = (data) => {
      return data.map((d, idx) => (
        <StyledTableRow key={`apply-info-${idx}`}>
          <StyledTableCell>{tabValue === 0 ? `${d.contactKor}` : `${d.contact}`}</StyledTableCell>
          <StyledTableCell>
            <a href={`mailto:${d.email}`}>{d.email}</a>
          </StyledTableCell>
          <StyledTableCell>{d.tel}</StyledTableCell>
        </StyledTableRow>
      ));
    };

    const mapDataRender = (data) => {
      return data.map((d, idx) => (
        <StyledTableRow key={`account-info-${idx}`}>
          <StyledTableCell style={{ backgroundColor: this.props.theme.palette.primary.main, color: '#fff', fontWeight: 'bold' }}>
            {d[0]}
          </StyledTableCell>
          <StyledTableCell align="left" style={{ backgroundColor: '#f8f8f8' }}>
            {d[1]}
          </StyledTableCell>
        </StyledTableRow>
      ));
    };

    const downloadButtonRender = (data) => {
      return data.map((d, idx) => (
        // <Grid item xs={3} key={`download-button-${idx}`}>
        <div style={{ width: '20%' }} className={classes.downloadBtn} key={`download-button-${idx}`}>
          <div
            style={
              idx < 1
                ? {
                    display: 'flex',
                    justifyContent: 'space-between',
                    backgroundColor: d.bgcolor,
                    backgroundImage: `url('/images/PRS2021/btn_background.png')`,
                    backgroundSize: '100%',
                    backgroundRepeat: 'no-repeat',
                    backgroundBlendMode: 'multiply',
                    padding: theme.spacing(2),
                    width: '100%',
                    height: tabValue === 0 ? '160px' : '180px',
                    cursor: 'pointer',
                    position: 'relative',
                    marginBottom: theme.spacing(1),
                  }
                : {
                    display: 'flex',
                    justifyContent: 'space-between',
                    backgroundColor: d.bgcolor,
                    padding: theme.spacing(2),
                    width: '100%',
                    height: tabValue === 0 ? '160px' : '180px',
                    cursor: 'pointer',
                    position: 'relative',
                    marginBottom: theme.spacing(1),
                  }
            }
            onClick={() => this.downloadFile(d)}
          >
            <div style={{ fontSize: tabValue === 0 ? '1.5em' : '1.3em', color: '#fff' }}>
              <span style={{ fontWeight: 'bold' }}>{tabValue === 0 ? d.title : d.titleEng}</span>
              <br />
              {tabValue === 0 ? '다운로드' : 'Download'}

              <img src="/images/PRS2021/ic_download.png" style={{ width: '1.7em', position: 'absolute', bottom: 16, right: 16 }} alt="" />
            </div>
          </div>
        </div>
        // </Grid>
      ));
    };

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={5} SIdx={0} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Sponsorship Opportunities</MainTitle>
            </Grid>
            <Grid item xs={8}>
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <ButtonGroup color="primary" fullWidth disableElevation style={{ width: '80%' }}>
                  <Button
                    variant={tabValue === 0 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 0)}
                    style={{ fontSize: 'large' }}
                  >
                    Korean
                  </Button>
                  <Button
                    variant={tabValue === 1 ? 'contained' : 'outlined'}
                    onClick={() => this.handleState('tabValue', 1)}
                    style={{ fontSize: 'large' }}
                  >
                    English
                  </Button>
                </ButtonGroup>
              </div>
            </Grid>
            {spaceDiv()}

            <Grid item xs={8}>
              <SubTitle>{tabValue === 0 ? '전시 및 광고 신청 ' : 'Important Deadlines'}</SubTitle>
              <Table>
                <TableBody style={{ fontSize: '1em' }}>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#237a9d', width: '30%', color: '#fff', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '전시 및 광고 신청 기한' : 'Application Deadline'}
                    </StyledTableCell>
                    <StyledTableCell style={{ color: '#000000' }}>
                      {tabValue === 0 ? '2022년 10월 30일 (일)' : 'October 30 (Fri), 2022'}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#237a9d', width: '30%', color: '#fff', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '결제 기한' : 'Payment Deadline'}
                    </StyledTableCell>
                    <StyledTableCell style={{ color: '#000000' }}>
                      {tabValue === 0 ? '2022년 10월 30일 (일)' : 'October 30 (Fri), 2022'}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
              <div style={{ display: 'flex', justifyContent: 'center', padding: theme.spacing(2, 0, 3) }}>
                {/* 사업자전용 가입 페이지로 이동 */}

                {tabValue === 0 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    disableElevation
                    onClick={() => this.props.history.push('/sponsor/application')}
                    style={{ color: '#fff', fontSize: 'large' }}
                  >
                    {tabValue === 0 ? '전시 및 광고 신청 바로가기' : 'GO TO APPLICATION'}
                  </Button>
                )}
                {/* <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  disableElevation
                  onClick={() => this.props.history.push('/sponsor/application')}
                  style={{ color: '#fff' }}
                >
                  {tabValue === 0 ? '전시 및 광고 신청 바로가기' : 'GO TO APPLICATION'}
                </Button> */}
                <div style={{ width: '15px' }} />
                {/* 가입한 사업자정보 확인 및 수정 */}
                {tabValue === 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    disableElevation
                    onClick={() => this.props.history.push('/sponsor/signin?moveTo=application')}
                    style={{ color: '#fff', fontSize: 'large' }}
                  >
                    {tabValue === 0 ? '전시 및 광고 신청 확인하기' : 'APPLICATION STATUS'}
                  </Button>
                )}

                {/* <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disableElevation
                  onClick={() => this.props.history.push('/sponsor/signin?moveTo=application')}
                >
                  {tabValue === 0 ? '전시 및 광고 신청 확인하기' : 'APPLICATION STATUS'}
                </Button> */}
                <div style={{ width: '15px' }} />
                {/* 입력한 부스정보 확인 및 수정 */}
                {/* <Button
                 variant="contained"
                  color="secondary"
                  size="large"
                  disableElevation
                  onClick={() => this.props.history.push('/sponsor/signin?moveTo=boothInfo')}
                >
                  Booth status
                </Button> */}
              </div>
            </Grid>
            {spaceDiv()}
            <Grid item xs={8}>
              <SubTitle>{tabValue === 0 ? '제공사항' : 'Packages'}</SubTitle>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell width="10%" style={{ fontWeight: 'bold' }}>
                      {tabValue === 0 ? '구분' : 'Type'}
                    </StyledTableCell>
                    <StyledTableCell align="right" style={{ fontWeight: 'bold' }}>
                      {tabValue === 0 ? '등급별' : 'Booth Name'}
                    </StyledTableCell>
                    <StyledTableCell
                      align="right"
                      style={tabValue === 1 ? { whiteSpace: 'pre', fontWeight: 'bold' } : { fontWeight: 'bold' }}
                    >
                      {tabValue === 0 ? '금액(VAT포함)' : 'Price\n(VAT-inclusive)'}
                    </StyledTableCell>
                    <StyledTableCell align="right" style={{ fontWeight: 'bold' }}>
                      {tabValue === 0 ? '제공사항' : 'Provided items'}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ fontSize: '1em' }}>
                  <StyledTableRow>
                    <StyledTableCell rowSpan={5} style={{ backgroundColor: '#f4f8fc', width: '15%', fontWeight: 'bold' }}>
                      Sponsors
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>Diamond</StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? '9,000 만원' : '90 million KRW'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      {/* <p style={{ color: '#C0010A', fontWeight: 'bold' }}>▶&nbsp; PRS KOREA 2021 Main Sponsor</p> */}
                      <p>▶&nbsp;{tabValue === 0 ? '오프라인 부스 (Main 3 booth)' : 'Offline booths (3 main booths)'}</p>
                      <p>▶&nbsp;{tabValue === 0 ? 'Gala Dinner 후원' : 'Support for a gala dinner'}</p>
                      <p>▶&nbsp;{tabValue === 0 ? 'Industrial Workshop 3 시간' : 'Industrial workshop for 3 hours'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학술대회 홈페이지 스폰서 업체 홍보'
                          : 'Promotion of the sponsor company on the website of PRS Korea 2022'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '사전 홍보 메일 배너 링크 등 홍보' : 'Promotion via a banner link of pre-event promotion emails'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학회 SNS 홍보 (인스타그램&페이스북 홍보)'
                          : 'Promotion via the SNS of the Society (Promotion via Instagram and Facebook)'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '연수교육 등 학회 자체 제작 강의록 5 회 광고'
                          : 'Advertisement placed 5 times in lecture notes of workshops and other sessions published by the Society'}
                      </p>
                      <p>▶&nbsp;{tabValue === 0 ? '포토존 광고' : 'Photo zone advertisement'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '초록집(E-book) 메인 칼라광고, 프로그램북 지면 광고'
                          : 'Main full-color advertisement in the abstract book and print advertisement in the conference program book'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '직원등록(8 명)-점심쿠폰, 주차권 포함'
                          : 'Staff registration (8 persons) - meal vouchers for free lunches and parking passes offered'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>Platinum</StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? '7,000 만원' : '70 million KRW'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>▶&nbsp;{tabValue === 0 ? '오프라인 부스 (2 booth)' : 'Offline booths (2 main booths)'}</p>
                      <p>▶&nbsp;{tabValue === 0 ? 'Welcome Reception 후원' : 'Support for a welcome reception'}</p>
                      <p>▶&nbsp;{tabValue === 0 ? 'Industrial Workshop 2 시간' : 'Industrial workshop for 2 hours'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학술대회 홈페이지 스폰서 업체 홍보'
                          : 'Promotion of the sponsor company on the website of PRS Korea 2022'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '사전 홍보 메일 배너 링크 등 홍보' : 'Promotion via a banner link of pre-event promotion emails'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학회 SNS 홍보 (인스타그램&페이스북 홍보)'
                          : 'Promotion via the SNS of the Society (Promotion via Instagram and Facebook)'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '연수교육 등 학회 자체 제작 강의록 5 회 광고'
                          : 'Advertisement placed 5 times in lecture notes of workshops and other sessions published by the Society'}
                      </p>
                      <p>▶&nbsp;{tabValue === 0 ? '포토존 광고' : 'Photo zone advertisement'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '초록집(E-book) 메인 칼라광고, 프로그램북 지면 광고'
                          : 'Main full-color advertisement in the abstract book and print advertisement in the program book'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '직원등록(6 명)-점심쿠폰, 주차권 포함'
                          : 'Staff registration (6 persons) - meal vouchers for free lunches and parking passes offered'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>Gold</StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? '5,000 만원' : '50 million KRW'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>▶&nbsp;{tabValue === 0 ? '오프라인 부스 (Main 2 booth)' : 'Offline booths (2 main booths)'}</p>
                      <p>▶&nbsp;{tabValue === 0 ? 'Industrial Workshop 1 시간' : 'Industrial workshop for 1 hour'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학술대회 홈페이지 스폰서 업체 홍보'
                          : 'Promotion of the sponsor company on the website of PRS Korea 2022'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '사전 홍보 메일 배너 링크 등 홍보' : 'Promotion via a banner link of pre-event promotion emails'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학회 SNS 홍보 (인스타그램&페이스북 홍보)'
                          : 'Promotion via SNS of the Society (Promotion via Instagram and Facebook)'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '연수교육 등 학회 자체 제작 강의록 5 회 광고'
                          : 'Advertisement placed 5 times in lecture notes of workshops and other sessions published by the Society'}
                      </p>
                      <p>▶&nbsp;{tabValue === 0 ? '포토존 광고' : 'Photo zone advertisement'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '초록집(E-book) 메인 칼라광고, 프로그램북 지면 광고'
                          : 'Main full-color advertisement in the abstract book and print advertisement in the program book '}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '직원등록(5 명)-점심쿠폰, 주차권 포함'
                          : 'Staff registration (5 persons) - meal vouchers for free lunches and parking passes offered'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>Silver</StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? '3,000 만원' : '30 million KRW'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>▶&nbsp;{tabValue === 0 ? '오프라인 부스 (2 booth)' : 'Offline booths (2 main booths)'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학술대회 홈페이지 스폰서 업체 홍보'
                          : 'Promotion of the sponsor company on the website of PRS Korea 2022'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '사전 홍보 메일 배너 링크 등 홍보' : 'Promotion via a banner link of pre-event promotion email'}
                      </p>
                      {/* <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '학술대회 홈페이지 스폰서 업체 홍보' : 'Promotion of sponsor companies on the conference website'}
                      </p> */}
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학회 SNS 홍보 (인스타그램&페이스북 홍보)'
                          : 'Promotion via the SNS of the Society (Promotion via Instagram and Facebook)'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '연수교육 등 학회 자체 제작 강의록 5 회 광고'
                          : 'Advertisement placed 5 times in lecture notes of workshops and other sessions published by the Society'}
                      </p>
                      <p>▶&nbsp;{tabValue === 0 ? '포토존 광고' : 'Photo zone advertisement'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '초록집(E-book) 메인 칼라광고, 프로그램북 지면 광고'
                          : 'Main full-color advertisement in the abstract book and print advertisement in the program book'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '직원등록(5 명)-점심쿠폰, 주차권 포함'
                          : 'Staff registration (5 persons) - meal vouchers for free lunches and parking passes offered'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>Bronze</StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? '2,000 만원' : '20 million KRW'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>▶&nbsp;{tabValue === 0 ? '오프라인 부스 (1 booth)' : 'Offline booth (1 main booth)'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학술대회 홈페이지 스폰서 업체 홍보'
                          : 'Promotion of the sponsor company on the website of PRS Korea 2022'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0 ? '사전 홍보 메일 배너 링크 등 홍보' : 'Promotion via a banner link of pre-event promotion emails'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '학회 SNS 홍보 (인스타그램&페이스북 홍보)'
                          : 'Promotion via the SNS of the Society (Promotion via Instagram and Facebook)'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '연수교육 등 학회 자체 제작 강의록 5 회 광고'
                          : 'Advertisement placed 5 times in lecture notes of workshops and other sessions published by the Society'}
                      </p>
                      <p>▶&nbsp;{tabValue === 0 ? '포토존 광고' : 'Photo zone advertisement'}</p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '초록집(E-book) 메인 칼라광고, 프로그램북 지면 광고'
                          : 'Main full-color advertisement in the abstract book and print advertisement in the program book'}
                      </p>
                      <p>
                        ▶&nbsp;
                        {tabValue === 0
                          ? '직원등록(5 명)-점심쿠폰, 주차권 포함'
                          : 'Staff registration (5 persons) - meal vouchers for free lunches and parking passes offered'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell rowSpan={2} style={{ backgroundColor: '#f4f8fc', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '일반 부스' : 'General Booths'}
                    </StyledTableCell>
                    {/* <StyledTableCell colSpan={3}>
                      <p style={{ fontSize: 'large' }}>{tabValue === 0 ? '추후 업데이트 예정' : 'To be updated'}</p>
                    </StyledTableCell> */}
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%' }}>
                      {tabValue === 0 ? (
                        <Typography style={{ fontSize: '1.0em' }}>
                          <b>A Type</b>
                          <br />
                          (5층 그랜드볼룸 (A1~A14))
                        </Typography>
                      ) : (
                        <Typography style={{ fontSize: '1.0em' }}>
                          <b>A Type</b>
                          <br />
                          (Grand Ballroom (A1~A14))
                        </Typography>
                      )}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === -0 ? 880 + '만원' : 'KRW 8,800,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '전시(오프라인부스 A zone 택 1)' : 'Exhibition (Select an offline booth in Zone A)'}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%' }}>
                      {tabValue === 0 ? (
                        <Typography style={{ fontSize: '1.0em' }}>
                          <b>B Type</b>
                          <br />
                          (2층 오키드룸 (B1~B19))
                        </Typography>
                      ) : (
                        <Typography style={{ fontSize: '1.0em' }}>
                          <b>B Type</b>
                          <br />
                          (Orchid (B1~B19))
                        </Typography>
                      )}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? 660 + '만원' : 'KRW 6,600,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '전시(오프라인부스 B zone 택 1)' : 'Exhibition (Select an offline booth in Zone B)'}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell rowSpan={4} style={{ backgroundColor: '#f4f8fc', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '프로그램 북 지면 광고' : 'Program book print advertisement'}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '표 4' : 'the outside back cover (fourth cover)'}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === -0 ? 220 + '만원' : 'KRW 2,200,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '프로그램 북 표지 맨 뒤' : 'the back cover of the program book'}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '표 2' : 'the inside front cover (second cover)'}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? 165 + '만원' : 'KRW 1,650,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>
                        {tabValue === 0
                          ? '프로그램 북 메인표지 뒷면'
                          : 'the other side of the main cover (front cover) of the program book'}
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '표 3' : 'the inside back cover (third cover)'}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? 110 + '만원' : 'KRW 1,100,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '표 4 뒷면 안쪽' : 'the other side of the outside back cover '}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '프로그램 북 내지' : 'an inside page'}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? 77 + '만원' : 'KRW 770,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '-' : '-'}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{ backgroundColor: '#f4f8fc', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '초록집 E-book 광고' : 'E-abstract book advertisement'}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#e9eff5', width: '15%', fontWeight: 'bold' }}>
                      {tabValue === 0 ? '초록집 내지' : 'an inside page'}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: '15%' }}>{tabValue === 0 ? 77 + '만원' : 'KRW 770,000'}</StyledTableCell>
                    <StyledTableCell className={classes.provide}>
                      <p>{tabValue === 0 ? '-' : '-'}</p>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </Grid>
            {spaceDiv()}
            <Grid item xs={8}>
              <SubTitle>{tabValue === 0 ? '문의처' : 'How to Apply'}</SubTitle>
            </Grid>
            <Grid item xs={8}>
              {tabValue === 1 && (
                <>
                  <div style={{ color: '#777777', padding: theme.spacing(1, 0, 2), fontSize: '1.2em' }}>
                    If you are interested in sponsorship, please contact the PRS KOREA 2022 Secretariat.
                    <br />
                    You are able to download sponsorship and general exhibition & Advertisement application form as below.
                    <br />
                    After receiving the application form, please make the bank transfer with the information below by the deadline.
                  </div>
                </>
              )}
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell style={{ fontWeight: 'bold' }}>{tabValue === 0 ? '연락처' : 'Contact'}</StyledTableCell>
                    <StyledTableCell style={{ fontWeight: 'bold' }}>E-mail</StyledTableCell>
                    <StyledTableCell style={{ fontWeight: 'bold' }}>Tel.</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{arrDataRender(APPLY_INFO)}</TableBody>
              </Table>
            </Grid>
            {spaceDiv()}

            {tabValue === 1 && (
              <>
                <Grid item xs={8}>
                  <SubTitle>Wire Transfer </SubTitle>
                  <Table>
                    {/* <TableHead>
                      <TableRow>
                        <StyledTableCell>Bank Name</StyledTableCell>
                        <StyledTableCell>KEB Hana Bank</StyledTableCell>
                      </TableRow>
                    </TableHead> */}
                    <TableBody>{mapDataRender(Object.entries(ACCOUNT_INFO))}</TableBody>
                  </Table>
                </Grid>
                {spaceDiv()}
              </>
            )}

            <Grid item xs={8}>
              <SubTitle> {tabValue === 0 ? '관련파일 다운로드' : 'File Download'}</SubTitle>
              {/* <Grid item container spacing={2}> */}

              <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', wordBreak: 'keep-all' }}>
                {downloadButtonRender(tabValue === 0 ? DOWNLOAD_BTN : DOWNLOAD_BTN_EN)}
              </div>
              {/* </Grid> */}
            </Grid>
            {spaceDiv()}
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SponsorInfo);
